import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Icon, Row, Col } from 'antd'
import PropTypes from 'prop-types'
import typo from "../../../../constants/dictionaries";
import Select from '../../../Common/Select'
import Button from '../../../../components/Buttons'
import AddTramModal from '../../FormKetQuaQuanTrac/QuanTrac/TramQuanTrac_2'
import { FastField } from "formik";
import helper from '../../../../helper/helper'
import Input from '../../../Common/Input'
import Api from '../../../../api';
import message from "../../../Messages";
import Api_quantrac from "../../../../api/api.quantrac";
import Api_spatial from "../../../../api/api.spatial"

let timeout;
let currentValue;

function fetch(value, callback, user, ApiTram) {
    if (timeout) {
        clearTimeout(timeout);
        timeout = null;
    }
    currentValue = value;
    if (value === "null") {
        callback([]);
    } else {
        function fake() {
            ApiTram({ token: user.access_token, page: 0, size: 0, strSearch: currentValue })
                .then(res => {
                    if (currentValue === value) {
                        callback(res && res.data);
                    }
                })
                .catch((err) => message.error(err.message))
        }
        timeout = setTimeout(fake, 800);
    }
}
class SelectTram extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            setModal: false,
            data: [],
            timeout: null
        }
    }
    componentDidUpdate = (prevProps) => {
        const { values, mode } = this.props

        if (mode === "edit") {
            if (values.tramquantrac_id) {
                if (values.tramquantrac_id !== prevProps.values.tramquantrac_id) {
                    this.getApiTram(values.tramquantrac_ten)
                }
            }
        }
    };
    componentDidMount = () => {
        const { values, mode } = this.props
        if (mode === "edit") {
            if (values.tramquantrac_id) {
                this.getApiTram(values.tramquantrac_ten)
            }
        }
    }

    getApiTram = (strSearch) => {
        const { user, ApiTram } = this.props
        ApiTram({ token: user.access_token, page: 0, size: 0, strSearch: strSearch })
            .then(res => {

                this.setState({ data: res && res.data })
            })
            .catch((err) => message.error(err.message))
    }
    SelectSearch = value => {
        const { user, ApiTram } = this.props;
        if (value && value !== "" && value !== undefined) {
            fetch(
                value,
                res => this.setState({ data: res }),
                user,
                ApiTram
            );
        } else {
            fetch(
                "null",
                res => this.setState({ data: res }),
                user,
                ApiTram
            );
        }
    };
    render() {
        const { setModal, data } = this.state;
        const { values, setFieldValue, handleGP, mode, ApiPost, ApiSpatial, view } = this.props
        return (
            <Row>
                <Row type="flex">
                    <Col span={view === "view" ? 24 : 21}>
                        <Select placeholder={typo.cscore_vi_tri_quan_trac}
                            width="100%"
                            label={typo.cscore_vi_tri_quan_trac}
                            name="tenTram"
                            name_value="id"
                            defaultValue={values.tramquantrac_id}
                            key={values.tramquantrac_id}
                            onSearch={this.SelectSearch}
                            onSelect={(value, e) => {
                                setFieldValue("tramquantrac_id", value);
                                setFieldValue("tramquantrac_ten", e.props.children);
                                handleGP(value)
                            }}
                            showArrow={false}
                            filterOption={false}
                            defaultActiveFirstOption={false}
                            notFoundContent={null}
                            dataSource={data}
                        // disabled={mode === "edit" ? true : false}
                        />
                    </Col>
                    <Col span={view === "view" ? 0 :3}>
                        <Row type="flex" align="bottom" style={{ height: "100%", float: "right" }}>
                            <Button type="primary" onClick={() => this.setState({ setModal: true })}>
                                <Icon style={{ color: '#fff' }} type="plus" />
                            </Button>
                        </Row>
                    </Col>
                </Row>
                <AddTramModal
                    handleCancel={() => this.setState({ setModal: false })}
                    handleAdd={() => { this.setState({ setModal: false }); }}
                    isOpen={setModal}
                    ApiPost={ApiPost}
                    ApiSpatial={ApiSpatial}
                />
            </Row>
        )
    };
}
SelectTram.propTypes = {
    handleGP: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({
    user: state.oidc.user,
    functions: state.functions
});

export default connect(mapStateToProps)(SelectTram);

